import { Box, Paper, Typography } from '@mui/material';
import React from 'react'

const WhyTecloqCards = ({ data }) => {
    console.log(data)
    return (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: "20px",
            padding: "5%",
            justifyContent: "center",
          }}
        >
          {data.map((item, index) => (
            <Paper
              key={index}
              elevation={3}
              sx={{
                borderRadius: "3%",
                textAlign: "center",
                border: "0.5px solid #FFC3EA",
                boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
                display: "flex",
                flexDirection: "column",
                padding: "20px",
                height: { xs: "auto", md: "700px" },
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={item.src}
                alt={item.alt}
                style={{
                  width: "70%",
                  height: "35%",
                  marginBottom: "20px",
                  objectFit: "contain",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Orbitron",
                  lineHeight: "120%",
                  fontSize: { xs: "20px", md: "28px" },
                  fontWeight: "700",
                  color: "#F005A2",
                  letterSpacing: "2%",
                  marginBottom: "10px",
                }}
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <Typography
                sx={{
                  fontFamily: "Inter",
                  lineHeight: "1.5",
                  padding: { xs: "5% 8%", md: "10% 15% 3% 15%" },
                  textAlign: "center",
                  fontSize: { xs: "14px", md: "16px" },
                  color: "#333",
                }}
              >
                {item.description}
              </Typography>
            </Paper>
          ))}
        </Box>
      );
    };


export default WhyTecloqCards